export default __webpack_public_path__ + "content/media/13.6656a55d.jpg";